<template>
  <div class="flex items-center justify-center mb-10">
    <div class="text-center">
      <div class="font-medium">
        {{ $t("Personalize your") }} {{ componentSelected.replaceAll("_", " ") }}
      </div>
      <div class="text-common-grey">
        {{ getsubHeader() }}
      </div>
    </div>
  </div>

  <div v-if="componentSelected == 'graph'">
    <GraphCreateForm
      v-if="!instanceToEdit"
      :object-type="objectType"
      :in-new-component-form="true"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="
        ($event) => {
          $emit('newComponentDataChange', $event)
          component_data = $event
        }
      " />
    <GraphUpdateForm
      v-else
      :in-new-component-form="true"
      :graph="instanceToEdit"
      :selected-object-type="objectType"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="
        ($event) => {
          $emit('newComponentDataChange', $event)
          component_data = $event
        }
      " />

    <div class="flex flex-row justify-between w-full gap-2">
      <div class="w-1/2 m-0 cancel-btn" @click="$emit('cancel')">
        {{ $t("Cancel") }}
      </div>
      <button
        :disabled="!component_data?.required_filled"
        type="button"
        class="w-1/2 primary-btn"
        @click="$emit('submitForm', component_data)">
        {{ instanceToEdit ? $t("Update Graph") : $t("Create Graph") }}
      </button>
    </div>
  </div>

  <div v-else-if="componentSelected == 'text'">
    <TextCreateAndEditForm
      :text="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>

  <div v-else-if="componentSelected == 'notes'">
    <NotesCreateAndEditForm
      :notes-to-edit="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>

  <div v-else-if="componentSelected == 'image'">
    <ImageCreateAndEditForm
      :image="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>

  <div v-else-if="componentSelected == 'video'">
    <VideoCreateAndEditForm
      :video="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>

  <div v-else-if="componentSelected == 'assets'">
    <AssetsCreateAndEditForm
      :assets-to-edit="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>

  <div v-else-if="componentSelected == 'team_card'">
    <TeamCardCreateAndEditForm
      :team-card="instanceToEdit"
      @submitForm="($event) => $emit('submitForm', $event)"
      @cancel="($event) => $emit('cancel')"
      @setComponentData="($event) => $emit('newComponentDataChange', $event)" />
  </div>
</template>

<script>
import GraphCreateForm from "@/components/forms/GraphCreateForm.vue"
import GraphUpdateForm from "@/components/forms/GraphUpdateForm.vue"
import TextCreateAndEditForm from "./TextCreateAndEditForm.vue"
import NotesCreateAndEditForm from "./NotesCreateAndEditForm.vue"
import ImageCreateAndEditForm from "./ImageCreateAndEditForm.vue"
import VideoCreateAndEditForm from "./VideoCreateAndEditForm.vue"
import AssetsCreateAndEditForm from "./AssetsCreateAndEditForm.vue"

import TeamCardCreateAndEditForm from "./TeamCardCreateAndEditForm"

export default {
  components: {
    GraphCreateForm,
    GraphUpdateForm,
    TextCreateAndEditForm,
    NotesCreateAndEditForm,
    ImageCreateAndEditForm,
    VideoCreateAndEditForm,
    AssetsCreateAndEditForm,
    TeamCardCreateAndEditForm
  },
  props: {
    componentSelected: {
      type: String,
      required: false
    },
    objectType: {
      type: String,
      default: ""
    },
    instanceToEdit: {
      type: Object,
      required: false
    }
  },

  emits: ["newComponentDataChange", "submitForm", "cancel"],
  data() {
    return {
      component_data: null
    }
  },
  watch: {},

  created() {},

  methods: {
    getsubHeader() {
      if (this.componentSelected == "graph") {
        return this.$t("Show the data in a chart")
      } else if (this.componentSelected == "image") {
        return this.$t("Show image on the page")
      } else if (this.componentSelected == "video") {
        return this.$t("Show video on the page")
      } else if (this.componentSelected == "text") {
        return this.$t("Show a text on the page")
      } else if (this.componentSelected == "notes") {
        return this.$t("Show notes on the page")
      }
    }
  }
}
</script>
